// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__YTcb8","root_compact":"style_root_compact__3THw-","root_md":"style_root_md__ESXGH","root_lg":"style_root_lg__A4XOf"};